export default "__VITE_ASSET__CSxH9T$7__"